import getDefaultComposeFormat from 'owa-editor/lib/utils/getDefaultComposeFormat';
export function createInitialComposeContentBlock(content) {
    var emptyDiv = document.createElement('div');
    if (content) {
        // NOTE: content can be HTML and is not escaped
        emptyDiv.innerHTML = content;
    }
    else {
        emptyDiv.appendChild(document.createElement('br'));
    }
    var elementStyle = emptyDiv.style;
    var defaultFormat = getDefaultComposeFormat();
    if (defaultFormat.fontFamily) {
        elementStyle.fontFamily = defaultFormat.fontFamily;
    }
    if (defaultFormat.fontSize) {
        elementStyle.fontSize = defaultFormat.fontSize;
    }
    if (defaultFormat.textColor) {
        elementStyle.color = defaultFormat.textColor;
    }
    if (defaultFormat.bold) {
        elementStyle.fontWeight = 'bold';
    }
    if (defaultFormat.italic) {
        elementStyle.fontStyle = 'italic';
    }
    if (defaultFormat.underline) {
        elementStyle.textDecoration = 'underline';
    }
    return emptyDiv.outerHTML;
}
var getDefaultComposeContentBlock = function () { return createInitialComposeContentBlock(); };
export default getDefaultComposeContentBlock;
//# sourceMappingURL=getDefaultComposeContentBlock.js.map